import useEmploymentTypes from '../generic/useEmploymentTypes';
import useJobTypes from '../generic/useJobTypes';
import useFileTypes from '../generic/useFileTypes';
// import useMandatoryRefreshPrompt from '../generic/useMandatoryRefreshPrompt';
import useBranches from './useBranches';
import useDepartments from './useDepartments';
import useFields from './useFields';
import usePositions from './usePositions';

const useInitialFetch = () => {
  useBranches();
  useFields();
  useFileTypes();
  usePositions();
  useJobTypes();
  useEmploymentTypes();
  useDepartments();
  // useMandatoryRefreshPrompt();
};

export default useInitialFetch;
